export const createEnumItems = (enums, name, asNumbers = false, withAbbr = false) => {
	let options = [];
	if (enums[name] && !enums[name]["isFetchingInfo"]) {
		const items = enums[name]["items"];
		for (let i in items) {
			if (items.hasOwnProperty(i)) {
				const o = {
					value: asNumbers ? 1 * items[i].id : items[i].id,
					label: (withAbbr && items[i].abbr ? items[i].abbr + ': ' : '') + items[i].title
				};
				if (items[i].parentId) {
					o['parentId'] = asNumbers ? 1 * items[i].parentId : items[i].parentId;
				}
				options.push(o)
			}
		}
		options.sort((a, b) => a.label > b.label ? 1 : -1)
	}

	return options;
};

export const getEnumTitle = (enums, name, value) => {
	return getEnumById(enums, name, value).title
};

export const getEnumById = (enums, name, value) => {
	value = value + ""; // for ===
	if (enums && enums[name] && enums[name]['items'] && enums[name]['items'].length) {
		for (let i = 0; i < enums[name]['items'].length; i++) {
			const e = enums[name]['items'][i];
			if (value === e.id) {
				return e
			}
		}
	}
	return {}
};

export const getEnumByAbbr = (enums, name, abbr) => {
	if (enums && enums[name] && enums[name]['items'] && enums[name]['items'].length) {
		for (let i = 0; i < enums[name]['items'].length; i++) {
			const e = enums[name]['items'][i];
			if (abbr === e.abbr) {
				return e
			}
		}
	}
	return abbr
};

export const getKey = (name, scope) => {
	if (!scope || name === 'xxx') {
		return name
	}
	return name;
};
